<template lang="pug">
.equipment-show-card
  q-card-section
    component(
      ref="actions",
      v-if="show_data['actions']",
      :is="getShowComponent('actions')",
      @refresh-table="refreshTable",
      @open-form="openForm",
      :parentData="{ row, grid, grid_key, path, data: show_data['actions'] }"
    )

  q-card-section
    component(
      ref="blocks",
      v-if="show_data['blocks']",
      :is="getShowComponent('blocks')",
      :parentData="{ row, show_details: false, data: show_data['blocks'] }"
    )
</template>

<script>
import showComponents from "../../../../shared/show_card_components/index";

export default {
  components: {
    showComponents,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      path: this.parentData.path,
      grid: this.parentData.grid,
      grid_key: this.parentData.grid_key,
      row: this.parentData.row,
    };
  },

  computed: {
    show_data() {
      return this.parentData.tabData || {};
    },
  },

  watch: {
    "parentData.row"(row) {
      this.row = row;
    },
  },

  methods: {
    refreshTable(data) {
      this.$emit("refresh-table", data);
    },

    refreshRow(data) {
      this.row = data.attr.data || data.attr;
      // Object.keys(showComponents).forEach(component => {
      //   if (this.$refs[component]) {
      //     try {
      //       this.$refs[component].refreshRow(this.row)
      //     } catch(e) {}
      //   }
      // })
    },

    openForm(data) {
      this.$emit("open-form", data);
    },
  },
};
</script>

<style lang="scss">
.equipment-show-card {
  min-height: 70vh;

  .remain-block {
    margin-top: 50px !important;
  }
}
</style>
